import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi =
  ApiDefinition['/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/questionnaire-agents/{agentId}/run-agent']['POST'];
type Input = ThisApi['params'] & ThisApi['body'];

const runQuestionnaireAgent = async ({
  agentId,
  questionnaireTemplateId,
  creatorId,
  fieldInputData,
  questionnaireId,
  userWorkflowId,
  rowIndicesToRun,
  stateOfFiling,
}: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>(
    '/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/questionnaire-agents/{agentId}/run-agent',
    { agentId, creatorId, questionnaireTemplateId },
  );
  const data = await formsBackendClient.post(path, {
    fieldInputData,
    questionnaireId,
    rowIndicesToRun,
    stateOfFiling,
    userWorkflowId,
  });
  return data.data;
};

export default runQuestionnaireAgent;
